export default class Cart {
    constructor() {
        this.updateCart();
    }

    updateCart() {
        jQuery( document.body ).on( 'updated_cart_totals removed_from_cart', function() {
        	let nbProducts = document.querySelectorAll( 'section.cart form table tbody tr' ).length;

        	if (nbProducts < 2) {
        		document.querySelector('aside.panier').style.display = 'none';
        	}
        } );
    }
}